export default {
  'current_lang': '語言 (ZH-TW)',
  'chinese_zh': '中文簡體',
  'chinese_tw': '中文繁體',
  'english': '英文 (English)',
  'general': {
    'list': {
      'display': '顯示',
      'to': '至',
      'of': '於',
      'records': '紀錄當中',
      'prev': '上一個',
      'next': '下一個',
    },
    'input': {
      'please_select_status': '請選擇一個狀態',
      'please_select_courier': '請選擇一個速遞商',
      'please_select_a_shipping_method': '請選擇速遞方式編碼',
      'please_select_supplier': 'Please select a supplier',
      'please_select_a_incoterm': 'Please select a incoterm',
    },
    'package': {
      'package': '包裝',
      'plastic_bag': 'PAK 袋',
      'letters': '信封袋',
    },
    'button': {
      'add': '加入',
      'delete': '刪除',
      'ok': '確定',
      'submit': '發送',
    },
    'action': '操作',
    'create': '創建',
    'edit': '編輯',
    'yes': '是',
    'no': '否',
  },
  'sidebar': {
    'dashboard': '儀表板',
    'delivery': 'Delivery',
    'shipment': '貨件管理',
    'label':'Labels',
    'pending_order': '待定訂單',
    'delivery_order': '送貨單',
    'delivery_audit_weight': '調整送貨單重量',
    'delivery_outbound': '已出貨訂單',
    'delivery_inbound': '待發貨訂單',
    'marketplace': '網上市集',
    'marketplace_order': '市集訂單',
    'marketplace_store': '網上市集店鋪',
    'marketplace_rma_product': 'RMA Product',
    'marketplace_faq': 'Marketplace FAQ',
    'shipper': '發貨人',
    'supplier': 'Supplier',
    'supplier_invoice': 'Supplier Invoice',
    'courier': '速遞商',
    'contact_message': '運送通知訊息',
    'comparison_tool': '比價工具',
    'tracking': 'Tracking Status',
    'marketplace_upload_order_tracking': '上傳追蹤號',
    'marketplace_pending_accept': 'Pending Accepts',
    'marketplace_order_shipment': '已上傳追蹤號',
    'contact_message_edit': 'Contact Message Edit'
  },
  'breadcrumb': {
    'home': '首頁',
    'dashboard': '儀錶盤',
    'delivery': '送貨管理',
    'pending': '訂單',
    'pending_order': '待定訂單',
    'inbound_list': '待發貨訂單',
    'outbound_list': '出貨單',
    'delivery_audit_weight': '調整訂單重量',
    'upload_delivery_audit_weight': '上傳更新送貨單重量',
    'audit_list': '調整送貨單重量',
    'not_audit_list': '正常送貨單',
    'order_create': '創建訂單',
    'order_edit': '修改訂單',
    'order_show': '訂單詳情',
    'order_upload': '上傳訂單',
    'order': '訂單',
    'order_list': '訂單列表',
    'order_detail': '訂單詳情',
    'marketplace_order': '網上市集訂單',
    'marketplace_order_list': '網上市集訂單列表',
    'store': '商店',
    'store_list': '商店列表',
    'store_create': 'Store Create',
    'store_edit': 'Store Edit',
    'rma_product': 'RMA Product',
    'rma_product_list': 'RMA Product List',
    'rma_product_create': 'RMA Product Create',
    'rma_product_edit': 'RMA Product Edit',
    'faq': 'FAQ',
    'faq_list': 'FAQ List',
    'faq_create': 'FAQ Create',
    'faq_edit': 'FAQ Edit',
    'shipper': '發貨人',
    'shipper_list': '發貨人列表',
    'shipper_create': '創建發貨人',
    'shipper_edit': '修改發貨人',
    'courier_list': '速遞商列表',
    'marketplace': '網上市集',
    'track': '送貨單追蹤號',
    'track_list': '追蹤號列表',
    'upload_marketplace_order_tracking': '上傳市集訂單追蹤號',
    'user': '用戶',
    'contact_message': '運送通知訊息',
    'contact_message_list': '運送通知訊息列表',
    'update_password': '更新密碼',
    'marketplace_order_shipment': '市集送貨單',
    'contact_message_edit': '修改運送通知訊息'
  },
  'delivery': {
    'shipment': {
      'courier': 'Courier',
      'reference_no': 'Reference No.',
      'tracking_no': 'Tracking No.',
      'status': 'Status',
      'courier_name': 'Courier Name',
      'courier_slug': 'Courier Slug',
      'pickup_note': 'Pickup Note',
      'signed_by': 'Signed By',
      'lead_time': 'Lead Time',
      'updated_at': 'Updated At',
      'operation': 'Operation',
      'filter_option': 'Filter Option',
      'shipment_date': 'Shipment Date',
      'please_enter_reference_no': 'Please enter your reference no.',
      'enter_reference_no': 'Enter Reference No..',
      'please_enter_tracking_no': 'Please enter your tracking No.',
      'enter_tracking_no': 'Enter Tracking No.',
      'search': 'Search',
      'reset': 'Reset',
    },
    'label': {
      'sender_info': '寄貨人資料',
      'item_details': '貨件資料',
      'pending_order': '待定訂單',
      'pending': '待定',
      'inbound': '待發貨',
      'outbound': '已出貨',
      'orders': '訂單',
      'filter_option': '過濾選項',
      'batch_id': '批次號碼',
      'enter_batch_id': '輸入批次號嗎 ..',
      'upload_order_date': '上傳訂單期間',
      'reference_no': '參考號碼',
      'please_enter_reference_no': '請輸入參考號碼',
      'enter_reference_no': '請輸入參考號碼',
      'waybill_number': '航空運單號',
      'tracking_no': '追蹤號號',
      'please_enter_tracking_no': '請輸入追蹤號碼',
      'enter_tracking_no': '輸入追蹤號碼',
      'please_enter_waybill_number': '請輸入航空運單號碼',
      'enter_waybill_number': '輸入航空運單號碼',
      'search': '搜尋',
      'reset': '重置',
      'print_all': '全部列印',
      'ship_date': '送貨日期',
      'weight': '重量',
      'product_type': '貨品類別',
      'package_num': '所須貼紙數量',
      'delivery_name': '收貨人',
      'pieces': '件',
      'api_failed_message': '錯誤訊息',
      'status': '狀態',
      'system_status': 'LME 系統狀態',
      'order_status': '訂單狀態',
      'tracking_status': 'Tracking Status',
      'active': '生效',
      'in_active': '已失效',
      'operation': '操作',
      'print_selected_orders': '列印已選訂單',
      'print_batch_orders': '列印整批訂單',
      'please_select_batch': 'You need to select Batch ID to Print Label',
      'please_select_order': 'Please select order ID to print label',
      'courier_name': '速遞商',
      'email': '電郵',
      'company': '公司名',
      'address': '地址',
      'address1': '地址1',
      'address2': '地址2',
      'city': '城市',
      'postal_code': '郵政編碼',
      'state': '省',
      'country': '國家',
      'country_code': '國家編碼',
      'shipment_content': '貨件內容',
      'phone': '電話',
      'district': '地區',
      'battery': '電池',
      'insurance_value': '保險價值',
      'shipping_code': '速遞方式編碼',
      'incoterm': 'Incoterm',
      'weight_unit': '重量單位',
      'height': '高',
      'width': '闊',
      'length': '長',
      'dimension_uom': '尺寸的量度單位',
      'remark': '備註',
      'courier_reference_id': '速遞商參考號碼',
      'number_of_pieces': '貨件數量',
      'declared_currency': '報關貨幣',
      'declared_value': '報關價值',
      'extra_instruction': '額外指示',
      'order_upload_date': '訂單上傳日',
      'created_date': '建立日期',
      'created_at': '建立日期',
      'not_allow_edit': '訂單狀態不對，你不能更新這個訂單',
      'update_pending_success': '更新待定送貨單成功',
      'create_pending_success': '創建待定送貨單成功',
      'download_ready_to_ship_order': '下載準備發貨送貨單',
      'pick_up_shipment': '設置送貨單為 - 已提貨',
      'download_below_order': '下載送貨單 - 下列顯示的全部',
      'download_not_delivered_order': '下載送貨單 - 未簽收'
    },
    'label_detail': {
      'line_no': '行數',
      'sku': '最小存貨單位 (SKU)',
      'product_name': '產品名稱',
      'description_export': '產品描述 - 出口',
      'description_import': '產品描述 - 進口',
      'country_of_origin': '來源地',
      'quantity': '數量',
      'item_declared_value': '報關價值',
      'hscode': '國際商品分類編碼 (HS Code)',
      'hsdescription': '國際商品分類編碼描述 (HS Code Description)',
      'created_at': 'Create At'
    },
    'warning': {
      'please_input_all_the_required_information': '請先輸入上述所需要的資料',
    }
  },
  'marketplace': {
    'marketplace_name': 'Marketplace Name',
    'marketplace_store': 'Marketplace Store',
    'marketplace_faq': 'Marketplace FAQ',
    'marketplace_rma_product': 'Marketplace RMA Product',
    'marketplace_courier': 'Marketplace Courier',
    'order': {
      'filter_option': 'Filter Option',
      'created_order_date': 'Created Order Date',
      'platform_order_id': 'Platform ID',
      'please_enter_platform_order_id': 'Please enter your platform order id',
      'enter_platform_order_id': 'Enter Platform ID',
      'please_enter_tracking_no': 'Please enter your tracking no.',
      'enter_tracking_no': 'Enter Tracking No..',
      'platform': 'Platform',
      'please_select_platform': 'Please select your platform',
      'search': 'Search',
      'reset': 'Reset',
      'sync_update': 'Sync & Update Order',
      'purchase_date': 'Purchase Date',
      'total_amount': 'Total Amount',
      'total_commission': 'Total Commission',
      'status': 'Status',
      'tracking_status':'Tracking Status',
      'updated_at': '更新日期',
      'active': 'Active',
      'in_active': 'InActive',
      'operation': 'Operation',
      'currency': 'Currency',
      'order_status': 'Order Status',
      'platform_order_status': 'Platform Order Status',
      'queue_job_status': 'Queue Job Status',
      'created_date': 'Created Date',
      'please_select_order': 'Please select an order ID to print the label',
      'courier_name': 'Courier Name',
      'email': 'Email',
      'company': 'Company Name',
      'battery': 'Battery',
      'bill_name': 'Bill Name',
      'bill_phone': 'Bill Phones Number',
      'bill_postal_code': 'Bill Postal Code',
      'bill_country': 'Bill Country',
      'bill_city': 'Bill City',
      'bill_district': 'Bill District',
      'bill_address': 'Bill Address',
      'shipping_name': 'Shipping Name',
      'shipping_phone': 'Shipping Phones Number',
      'shipping_postal_code': 'Shipping Postal Code',
      'shipping_country': 'Shipping Country',
      'shipping_city': 'Shipping City',
      'shipping_district': 'Shipping District',
      'shipping_address': 'Shipping Address',
      'created_at': 'Create At',
      'not_allow_edit': 'Not allow to edit this order, please check the order status',
      'update_pending_success': 'Update Pending Delivery Label Success',
      'create_pending_success': 'Create Pending Delivery Label Success',
      'platform_courier_name': 'Platform Courier Name',
      'platform_order_item_id': 'Platform Order Item Id',
      'tracking_no': 'Tracking No',
      'message': 'Message'
    },
    'order_detail': {
      'platform_order_id': 'Platform Order Id',
      'order_item_id': 'Order Item Id',
      'title': 'Title',
      'quantity_ordered': 'Quantity Ordered',
      'shipping_type': 'Shipping Type',
      'item_price': 'Item Price',
      'imei_code': 'IMEI Code',
      'shipping_price': 'Shipping Price',
      'total_commission': 'Total Commission',
      'tracking_no': 'Tracking No',
      'status': 'Status',
      'created_at': 'Create At'
    },
    'order_risk': {
      'platform_order_id': 'Platform Order Id',
      'platform': 'Platform',
      'platform_risk_id': 'Platform Risk Id',
      'checkout_id': 'Checkout Id',
      'recommendation': 'Recommendation',
      'display': 'Display',
      'cause_cancel': 'Cause Cancel',
      'message': 'Message',
      'merchant_message': 'Merchant Message'
    },
    'contact': {
      'message_type': 'Message Type',
      'contact_user_message': 'Contact User Message'
    },
    'store': {
      'store_account': 'Store Account',
      'store_name': 'Store Name',
      'store_user_id': 'Store User ID',
      'store_token': 'Store Token',
      'store_email': 'Store Email',
      'store_currency': 'Store Currency',
      'service_url': 'Service Url',
      'time_schedule': 'Time Schedule',
      'debug': 'Debug',
      'remark': 'Remark',
      'status': 'Status',
      'operation': 'Operation',
      'created_at': 'Create At',
      'active': 'Active',
      'in_active': 'InActive',
      'submit': 'Submit',
      'update': 'Update',
      'success_message': 'Update Marketplace Store Success!'
    },
    'rma_product': {
      'platform': 'Platform',
      'platform_order_id': 'Platform Order Id',
      'order_item_id': 'Order Item ID',
      'imei_code': 'Imei Code',
      'product_name': 'Product Name',
      'qty': 'Qty',
      'conditions': 'Conditions',
      'tracking_number': 'Tracking Number',
      'return_requested_at': 'Return Requested At',
      'type': 'Type',
      'cost': 'Cost',
      'selling_price': 'Platform Selling Price',
      'deal_price': 'Deal Price',
      'sold_date': 'Re-Sold Date',
      'status': 'Status',
      'operation': 'Operation',
      'created_at': 'Create At',
      'updated_at': 'Updated At',
      'active': 'Active',
      'in_active': 'InActive',
      'submit': 'Submit',
      'update': 'Update',
      'filter_option': 'Filter Option',
      'please_enter_platform_order_id': 'Please enter platform order id',
      'please_enter_document_no': 'Please enter your delivery No.',
      'please_enter_tracking_no': 'Please enter your Tracking No.',
      'enter_platform_order_id': 'Enter Platform Order Id',
      'please_select_platform': 'Please select your platform',
      'please_enter_imei_code': 'Please enter imei code',
      'please_enter_product_name': 'Please enter Product Name',
      'search': 'Search',
      'reset': 'Reset',
      'document_no': 'Delivery No.',
      'remark': "Remark",
      'settled': {
        'title': 'Are you sure?',
        'text': 'You will not be able to revert this!',
        'confirm_button': 'Yes, settled it!'
      },
      'manual_create': 'Manual Create',
      'success_message': 'Create Marketplace RMA Product Success!',
      'return_tracking_number': 'Return Tracking No.',
      'warehouse_received_at': 'Warehouse Received At',
      'book_in': 'Book In',
      'book_in_rma_product':'Book In Item',
      'add_to_rma_product':'Select Item'
    },
    'faq': {
      'title': 'Title',
      'content': 'Content',
      'platform': 'Platform',
      'status': 'Status',
      'operation': 'Operation',
      'created_at': 'Create At',
      'active': 'Active',
      'in_active': 'InActive',
      'submit': 'Submit',
      'update': 'Update',
      'created_date': '建立日期',
      'filter_option': 'Filter Option',
      'please_enter_title': 'Please enter title',
      'enter_title': 'Enter Title',
      'please_select_platform': 'Please select your platform',
      'search': 'Search',
      'reset': 'Reset',
      'success_message': 'Update Marketplace FAQ Success!'
    }
  },
  'track': {
    'delivery_order_no': 'delivery Order No',
    'waybill_number': 'Waybill Number',
    'route_description': 'Route Description',
    'route_date': 'Route Date',
    'route_status': 'Route Status',
    'updated_by': 'Updated By',
    'created_by': 'Created By',
    'collect': 'Collect',
    'signed': 'Signed',
    'transporting': 'Transporting',
    'operation': 'Operation'
  },
  'shipper': {
    'courier_name': 'Courier Name',
    'shipper_account': 'Shipper Account',
    'billing_account': 'Billing Account',
    'duty_account': 'Duty Account',
    'shipper_id': 'Shipper ID',
    'shipper_name': 'Shipper Name',
    'registered_account': 'Registered Account',
    'address_line_1': 'Address Line 1',
    'address_line_2': 'Address Line 2',
    'city': 'City',
    'postal_code': 'Postal Code',
    'division': 'Division',
    'division_code': 'Division Code',
    'country_code': 'Country Code',
    'country_name': 'Country Name',
    'contact_person': 'Contact Person Name',
    'contact_phone': 'Contact Phone',
    'status': 'Status',
    'operation': 'Operation',
    'active': 'Active',
    'in_active': 'InActive',
    'submit': 'Submit',
    'success_message': 'Update Shipper Account Success!'
  },
  'courier': {
    'courier_name': 'Courier Name',
    'incoterm': 'Incoterm',
    'fuel_surcharge': 'Fuel Surcharge (%)',
    'currency': 'Currency',
    'lead_time': 'Lead Time',
    'status': 'Status'
  },
  'supplier': {
    'primary_name': 'Primary Name',
    'secondary_name': 'Secondary Name',
    'address': 'Address',
    'postal_address': 'Postal Address',
    'payee_bank_name': 'Payee Bank Name',
    'payee_bank_swiftbic': 'Payee Bank Swiftbic',
    'payee_bank_account_name': 'Payee Bank Account Name',
    'email': 'Email',
    'tel': 'Tel',
    'fax': 'Fax',
    'active': 'Active',
    'in_active': 'In Active',
    'mobile': 'Mobile',
    'br': 'BR',
    'contact_person': 'Contact Person',
    'status': 'Status',
    'operation': 'Operation',
    'success_message': 'Update supplier successful',
    'update': 'Update',
    'invoice': {
      'label': {
        'search': 'Search',
        'reset': 'Reset',
        'invoice_date': 'Invoice Date',
        'supplier_name': 'Supplier Name',
        'filter_option': 'Filter Option',
        'invoice_no': 'Invoice No.',
        'please_enter_invoice_no': 'Please enter your invoice no.',
        'enter_invoice_no': 'Enter Invoice No.',
        'tracking_no': 'Tracking No.',
        'please_enter_tracking_no': 'Please enter your tracking No.',
        'enter_tracking_no': 'Enter Tracking No.',
        'batch_id': 'Batch Id',
        'supplier': 'Supplier',
        'description': 'Description',
        'date': 'Date',
        'total_amount': 'Total Amount',
        'remark': 'Remark',
        'status': 'Status',
        'operation': 'Operation',
        'created_at': 'Create At',
        'updated_at': 'Updated At',
      },
      'label_detail': {
        'batch_id': 'Batch Id',
        'tracking_no': 'Tracking No.',
        'shipment_date': 'Shipment Date',
        'product': 'Product',
        'shipment_weight': 'Weight',
        'shipment_weight_unit': 'Weight Unit',
        'operation_fee': 'Operation Fee',
        'kilogram_fee': 'Kilogram Fee',
        'peak_season_surcharge': 'Peak Season Surcharge',
        'discount': 'Discount',
        'pickup_fee': 'Pickup Fee',
        'returned_fee': 'Returned Fee',
        'total_amount': 'Total Amount',
        'remark': 'Remark',
        'amount': 'Amount',
        'status': 'Status',
        'shipment_status': 'Shipment Status',
      }
    },
  },
  'comparison_tool': {
    'destination_country': 'Destination Country',
    'destination_state': 'Destination State',
    'warehouse': 'Warehouse',
    'postal_code': 'Postal Code',
    'weight': 'Weight (kg)',
    'service_type': 'Service Type',
    'battery_type': 'Battery Type',
    'incoterm': 'Incoterm',
    'max_dimension': 'Max Dimension'
  },
  'note': {
    'label': {
      'creator': 'Creator',
      'note': 'Note',
      'created_at': 'Created At',
      'operation': 'Operation'
    },
    'update_success': 'Update Message Success'
  },
  'login': {
    'sign_in_account': 'Sign In to your account',
    'login': 'Login',
    'email': 'Email',
    'password': 'Password',
    'forgot_password': 'Forgot password?',
    'register_now': 'Register Now!',
    'sign_up': 'Sign up'
  },
  'error': {
    'search': 'Search',
    'oops_message': 'Oops! You are lost.',
    'page_not_found': 'The page you are looking for was not found.',
    'houston_problem': 'Houston, we have a problem!',
    'what_looking_for': 'What are you looking for?',
    'temporarily_unavailable': 'The page you are looking for is temporarily unavailable.'
  },
  'operation': {
    'delete': {
      'title': 'Are you sure?',
      'text': 'You will not be able to revert this!',
      'confirm_button': 'Yes, delete it!'
    },
    'rma_lost': {
      'title': 'Are you sure?',
      'text': 'You will not be able to revert this!',
      'confirm_button': 'Yes, Mark As Lost!'
    },
    'claim': {
      'title': 'Are you sure?',
      'text': 'You will claim the invoice item!',
      'confirm_button': 'Yes, claim it!'
    }
  },
  'dashboard': {
    'marketplace': {
      'marketplace_order': '網上市集訂單',
      'order_request_date': '訂購日期',
      'total': '總數',
      'total_amounts': 'Total Amounts',
      'currency': 'Currency'
    },
    'currency': {
      'currency_rate': '貨幣',
      'from': '從',
      'to': '到',
      'rate': '匯率',
      'updated_at': '更新日期'
    }
  }
}
